import type { AppState } from "./db";
import type { Deck, SessionLog, Settings, WordProgress } from "./types";

/** 整包同步的数据结构（与 AppState 的业务字段对应） */
export interface SyncData {
  decks?: Deck[];
  progress?: Record<string, WordProgress>;
  settings?: Settings;
  logs?: SessionLog[];
}

/** 取出需要上雲的業務欄位（onboarding 設定保留在本機） */
export function toSyncData(state: AppState): SyncData {
  return {
    decks: state.decks,
    progress: state.progress,
    logs: state.logs,
    settings: state.settings,
  };
}

/** 一份客户端快照：clientTs 用于 last-write-wins 冲突裁决 */
export interface Snapshot {
  clientTs: string;
  data: SyncData;
}

/**
 * 合并远端与本地快照（last-write-wins）：
 * - 无远端数据 → 用本地
 * - clientTs 较新者胜出
 * - clientTs 相等或本地更新 → 用本地（平局偏向本地，避免回退）
 */
export function mergeStates(remote: Snapshot | null, local: Snapshot): SyncData {
  if (!remote) return local.data;

  const remoteTime = new Date(remote.clientTs).getTime();
  const localTime = new Date(local.clientTs).getTime();

  if (remoteTime > localTime) return remote.data;
  return local.data;
}
